import axios from 'axios';
import { getApiKey } from './localStorage';

const BRANDFOLDER_URL = 'https://brandfolder.com/api/v4';

export const getCollectionsWithOrganizations = () => {
  return axios
    .get(`${BRANDFOLDER_URL}/collections`, {
      headers: {
        Authorization: `Bearer ${getApiKey()}`,
        'Content-Type': 'application/json'
      },
      params: {
        fields: 'card_image',
        include: 'brandfolder',
        per: 3000
      }
    })
    .then(response => {
      return response.data.data.map(collection => {
        return {
          id: collection.id,
          attributes: collection.attributes,
          type: collection.type,
          brandfolder: response.data.included.find(
            include =>
              include.type === 'brandfolders' &&
              include.id === collection.relationships.brandfolder.data.id
          )
        };
      });
    });
};

export const getCollectionWithGenericFileSections = collectionId => {
  function getCollection() {
    return axios
      .get(`${BRANDFOLDER_URL}/collections/${collectionId}`, {
        headers: {
          Authorization: `Bearer ${getApiKey()}`,
          'Content-Type': 'application/json'
        },
        params: {
          include: 'brandfolder'
        }
      });
  }

  function getSections() {
    return axios
      .get(`${BRANDFOLDER_URL}/collections/${collectionId}/sections`, {
        headers: {
          Authorization: `Bearer ${getApiKey()}`,
          'Content-Type': 'application/json'
        },
        params: {
          include: 'brandfolder'
        }
      });
  }

  return Promise.all([getCollection(), getSections()])
    .then(([collectionResponse, sectionsResponse]) => {
      return {
        id: collectionResponse.data.data.id,
        attributes: collectionResponse.data.data.attributes,
        type: collectionResponse.data.data.type,
        genericFileSections: sectionsResponse.data.data.filter(
          section => section.attributes.default_asset_type === 'GenericFile'
        )
      };
    });
};



// WEBPACK FOOTER //
// ./src/services/collection.js